import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";

const DateTimeNew = ({ value, setValue }) => {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      sx={{ backgroundColor: "white" }}
    >
      <DateTimePicker
        renderInput={(props) => (
          <CustomTextField
            {...props}
            fullWidth
            size="small"
            sx={{
              // marginLeft: "10px",
              // marginRight: "10px",
              "& .MuiInputBase-root": {
                backgroundColor: "white",
                borderRadius: "8px",
              },
              "& .MuiSvgIcon-root": {
                width: "18px",
                height: "18px",
              },
              "& .MuiFormHelperText-root": {
                display: "none",
              },
            }}
          />
        )}
        sx={{
          backgroundColor: "white",
          borderRadius: "8px",
          // marginLeft: "10px",
          // marginRight: "10px",
        }}
        placeholder="DateTimePicker"
        value={value}
        onChange={(newValue) => {
          setValue(newValue);
        }}
      />
    </LocalizationProvider>
  );
};

export default DateTimeNew;
